import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "12", "height": "20", "viewBox": "0 0 12 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M3.4518 10.0005L10.9273 2.77423C11.3679 2.34759 11.3679 1.6571 10.9273 1.23182C10.4867 0.805863 9.77185 0.805863 9.33127 1.23182L1.05846 9.22943C0.618535 9.65539 0.618535 10.3462 1.05846 10.7709L9.33127 18.7681C9.55225 18.9811 9.84106 19.0876 10.1299 19.0876C10.4188 19.0876 10.7076 18.9811 10.9273 18.7674C11.3679 18.3415 11.3679 17.652 10.9273 17.226L3.4518 10.0005Z", "fill": "currentColor" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const ArrowStrokeBackIcon = __component__.exports;
export {
  ArrowStrokeBackIcon as default
};
